const rootSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
export const pxToRem = (px)=>`${1 / (rootSize || 16) * px}rem`;
